import { LocationBookingModel } from "types/generated/models";
import { useGetQuery } from "../../../hooks/useClientPortalQuery";
import { useClientPortalSelector, selectBookingType } from "../../../redux";
import { useAppointmentBookingApi } from "../../../hooks/useAppointmentBookingApi";

export interface ILocationsHook {
    locations?: LocationBookingModel[] | null;
    isLoading: boolean;
}

export function useLocations(): ILocationsHook {
    const { getEndpoint } = useAppointmentBookingApi();
    const bookingType = useClientPortalSelector(selectBookingType);

    const { data, isLoading } = useGetQuery<LocationBookingModel[]>({
        url: `${getEndpoint("GetLocations")}?type=${bookingType}`,
    });

    return {
        locations: data,
        isLoading,
    };
}
